import React from 'react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import SubCommentTextEditor from '../../Common/SubCommentTextEditor/SubCommentTextEditor';
import ProfileImage from '../../Common/ProfileImage/ProfileImage';

// #region STYLES
const avatar = css`
  margin-right: 8px;
`;

const Wrapper = styled.div`
  width: 100%;
`;
const AvatarWrapper = styled.div`
  float: left;
`;
const EditorWrapper = styled.div`
  float: left;
  width: 100%;
  padding-left: 40px;
  margin-left: -40px;
`;
// #endregion

function EditSubComment({ fullComment, author, token }) {
  return (
    <Wrapper>
      <AvatarWrapper>
        {/* 🚨 CORREÇÃO: Repassando o perfil dinâmico em vez de forçar o usuário */}
        <ProfileImage css={avatar} profile={author} size="xs" />
      </AvatarWrapper>
      <EditorWrapper>
        <SubCommentTextEditor
          commentMediaEdit={fullComment.media}
          commentLink={fullComment.linkInfo}
          token={token}
          autoFocus
          commentEdit={fullComment}
          postId={fullComment.subComment.itemId}
          userId={fullComment.subComment.userId}
          isEditComment
        />
      </EditorWrapper>
    </Wrapper>
  );
}

export default EditSubComment;
